import { createContext } from 'react'

/**
 * In a form, the id (or ids) of the label above the field a cell is drawn in: its name, and "Required Field" for a
 * required one. A cell's input takes it as its aria-labelledby, so it's named as the field. Undefined in the grid.
 */
export const FormFieldLabel = createContext<string | undefined>(undefined)
